import { ReactNode } from 'react';
import { View } from 'react-native';
import { Card, ICardProps } from '@/common/components/Card/Card';
import { IRadioButtonBaseProps } from '@/common/components/RadioButton/RadioButtonBase/RadioButtonBase';
import { RadioButtonBase } from '@/common/components/RadioButton/RadioButtonBase/RadioButtonBase';
import { Stack } from '@/common/components/Stack/Stack';
import { styles } from './RadioButtonOption.styles';

export const RadioButtonOption = ({
  label,
  description,
  checked,
  disabled,
  rightContent,
  onPress,
  value,
  className,
  error,
  radioButtonProps,
  variant,
  children,
  ...cardProps
}: TRadioButtonOptionProps) => {
  if (variant === 'card') {
    return (
      <Card
        onPress={onPress}
        disabled={disabled}
        {...cardProps}
        className={styles.host({ error, checked, className })}
      >
        <Stack justify="between" gap="md">
          <Stack justify="between" gap="md" horizontal>
            <RadioButtonBase
              label={label}
              description={description}
              checked={checked}
              value={value}
              disabled={disabled}
              onPress={onPress}
              {...radioButtonProps}
            >
              {children}
            </RadioButtonBase>
            {rightContent && <View>{rightContent}</View>}
          </Stack>
        </Stack>
      </Card>
    );
  }

  return (
    <RadioButtonBase
      label={label}
      description={description}
      checked={checked}
      value={value}
      disabled={disabled}
      onPress={onPress}
      className={className}
      {...radioButtonProps}
    >
      {children}
    </RadioButtonBase>
  );
};

export type TRadioButtonOptionProps<T extends string = string> = Omit<
  ICardProps,
  'children'
> &
  IRadioButtonBaseProps & {
    className?: string;
    onPress?: (value: string) => void;
    variant?: 'plain' | 'card';
    value: T;
    rightContent?: ReactNode;
    bottomContent?: ReactNode;
    radioButtonProps?: IRadioButtonBaseProps;
    error?: boolean;
  };
